import api from "../api/axios";
import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

export interface CreateJobTitlePayload {
  job_title: string;
  status: number;
}

export interface UpdateJobTitlePaylod extends CreateJobTitlePayload {}

export const JOBTITLES_QUERY_KEY = ["job-title"];
export const VIEW_JOBTITLES_QUERY_KEY = ["view-job-title"];

export const jobtitleService = {
  createJobTitle: async (payload: CreateJobTitlePayload) => {
    return requestWithRefresh(async () => {
      const response = await api.post("api/job-title", payload, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  showJobTitle: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.get(`api/job-title/${id}`, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  updateJobTitle: async (id: number, payload: UpdateJobTitlePaylod) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(`api/job-title/${id}`, payload, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  toggleStatus: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(
        `api/job-title/${id}/toggle-status`,
        {},
        {
          headers: getAuthHeaders(),
        },
      );

      return response.data;
    });
  },

  viewAllJobTitle: async () =>
    requestWithRefresh(() =>
      api
        .get(`api/view-job-title`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),

  getAllJobTitles: async () =>
    requestWithRefresh(() =>
      api
        .get(`api/job-title`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
};
